/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Public API
 * API that powers FreightSimple\'s SPA
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Currency } from './Currency';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
    CurrencyToJSONTyped,
} from './Currency';

/**
 * 
 * @export
 * @interface CreateAccountRequest
 */
export interface CreateAccountRequest {
    /**
     * 
     * @type {boolean}
     * @memberof CreateAccountRequest
     */
    isPersonalSelected: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof CreateAccountRequest
     */
    isBrokerSelected: boolean;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    password: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    phoneNumberExtension: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    utmSource?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    utmMedium?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    utmCampaignId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    utmCampaignName?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    utmContent?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    utmTerm?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    gclid?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    msclkid?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    oppref?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    visitorId?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    shipmentFrequency: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    referralCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    prefilledCode?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    referrer?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    landingPage?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    firstTouchReferrer?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateAccountRequest
     */
    firstTouchLandingPage?: string;
    /**
     * 
     * @type {Currency}
     * @memberof CreateAccountRequest
     */
    companyCurrency: Currency;
}



/**
 * Check if a given object implements the CreateAccountRequest interface.
 */
export function instanceOfCreateAccountRequest(value: object): value is CreateAccountRequest {
    if (!('isPersonalSelected' in value) || value['isPersonalSelected'] === undefined) return false;
    if (!('isBrokerSelected' in value) || value['isBrokerSelected'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('password' in value) || value['password'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('phoneNumberExtension' in value) || value['phoneNumberExtension'] === undefined) return false;
    if (!('shipmentFrequency' in value) || value['shipmentFrequency'] === undefined) return false;
    if (!('companyCurrency' in value) || value['companyCurrency'] === undefined) return false;
    return true;
}

export function CreateAccountRequestFromJSON(json: any): CreateAccountRequest {
    return CreateAccountRequestFromJSONTyped(json, false);
}

export function CreateAccountRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateAccountRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'isPersonalSelected': json['isPersonalSelected'],
        'isBrokerSelected': json['isBrokerSelected'],
        'email': json['email'],
        'password': json['password'],
        'name': json['name'],
        'companyName': json['companyName'],
        'phoneNumber': json['phoneNumber'],
        'phoneNumberExtension': json['phoneNumberExtension'],
        'utmSource': json['utmSource'] == null ? undefined : json['utmSource'],
        'utmMedium': json['utmMedium'] == null ? undefined : json['utmMedium'],
        'utmCampaignId': json['utmCampaignId'] == null ? undefined : json['utmCampaignId'],
        'utmCampaignName': json['utmCampaignName'] == null ? undefined : json['utmCampaignName'],
        'utmContent': json['utmContent'] == null ? undefined : json['utmContent'],
        'utmTerm': json['utmTerm'] == null ? undefined : json['utmTerm'],
        'gclid': json['gclid'] == null ? undefined : json['gclid'],
        'msclkid': json['msclkid'] == null ? undefined : json['msclkid'],
        'oppref': json['oppref'] == null ? undefined : json['oppref'],
        'visitorId': json['visitorId'] == null ? undefined : json['visitorId'],
        'shipmentFrequency': json['shipmentFrequency'],
        'referralCode': json['referralCode'] == null ? undefined : json['referralCode'],
        'prefilledCode': json['prefilledCode'] == null ? undefined : json['prefilledCode'],
        'referrer': json['referrer'] == null ? undefined : json['referrer'],
        'landingPage': json['landingPage'] == null ? undefined : json['landingPage'],
        'firstTouchReferrer': json['firstTouchReferrer'] == null ? undefined : json['firstTouchReferrer'],
        'firstTouchLandingPage': json['firstTouchLandingPage'] == null ? undefined : json['firstTouchLandingPage'],
        'companyCurrency': CurrencyFromJSON(json['companyCurrency']),
    };
}

  export function CreateAccountRequestToJSON(json: any): CreateAccountRequest {
      return CreateAccountRequestToJSONTyped(json, false);
  }

  export function CreateAccountRequestToJSONTyped(value?: CreateAccountRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'isPersonalSelected': value['isPersonalSelected'],
        'isBrokerSelected': value['isBrokerSelected'],
        'email': value['email'],
        'password': value['password'],
        'name': value['name'],
        'companyName': value['companyName'],
        'phoneNumber': value['phoneNumber'],
        'phoneNumberExtension': value['phoneNumberExtension'],
        'utmSource': value['utmSource'],
        'utmMedium': value['utmMedium'],
        'utmCampaignId': value['utmCampaignId'],
        'utmCampaignName': value['utmCampaignName'],
        'utmContent': value['utmContent'],
        'utmTerm': value['utmTerm'],
        'gclid': value['gclid'],
        'msclkid': value['msclkid'],
        'oppref': value['oppref'],
        'visitorId': value['visitorId'],
        'shipmentFrequency': value['shipmentFrequency'],
        'referralCode': value['referralCode'],
        'prefilledCode': value['prefilledCode'],
        'referrer': value['referrer'],
        'landingPage': value['landingPage'],
        'firstTouchReferrer': value['firstTouchReferrer'],
        'firstTouchLandingPage': value['firstTouchLandingPage'],
        'companyCurrency': CurrencyToJSON(value['companyCurrency']),
    };
}

